import { DbSaveReceipt } from "../../../data/usecases/save-receipt";
import { SaveReceipt } from "../../../domain/usecases/save-receipt";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl, makeAxiosHttpClient } from "../http";

export const makeDbSaveReceipt = (): SaveReceipt =>
  new DbSaveReceipt(makeApiUrl("/receipt"), makeAuthorizeHttpClientDecorator());
